var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path2, _path3, _path4, _path5, _path6, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path7, _path8, _path9, _path10, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinciplesM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 172,
    viewBox: "0 0 344 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.8945,
    y: 171.442,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(180 42.8945 171.442)",
    fill: "#F9F5F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.924 171.5L42.9337 159.276C42.9337 159.276 42.9337 159.276 42.924 159.276C37.8517 159.276 33.7219 155.163 33.7219 150.111C33.7219 145.059 37.8517 140.945 42.924 140.945C42.924 140.945 42.924 140.945 42.9337 140.945V128.722C42.9337 128.722 42.9337 128.722 42.924 128.722C31.0789 128.722 21.4492 138.313 21.4492 150.111C21.4492 161.909 31.0789 171.5 42.924 171.5Z",
    fill: "#3098F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8438,
    y: 128.777,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 85.8438 128.777)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 214.523,
    y: 128.777,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 214.523 128.777)",
    fill: "#FFCC00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 257.418,
    y: 128.777,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 257.418 128.777)",
    fill: "#3098F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 300.168,
    y: 128.777,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 300.168 128.777)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 129,
    width: 43,
    height: 43,
    transform: "rotate(-180 343 129)",
    fill: "#3098F3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 171.629,
    y: 128.777,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 171.629 128.777)",
    fill: "#082C4E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 171.629,
    y: 128.777,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 171.629 128.777)",
    fill: "#082C4E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8438,
    y: 171.499,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 85.8438 171.499)",
    fill: "#082C4E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8438,
    y: 171.499,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 85.8438 171.499)",
    fill: "#082C4E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 128.777,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 128.738 128.777)",
    fill: "#FE6571"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 214.523,
    y: 171.499,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 214.523 171.499)",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 257.418,
    y: 171.499,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 257.418 171.499)",
    fill: "#FE6571"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 300.168,
    y: 171.499,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 300.168 171.499)",
    fill: "#082C4E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 172,
    width: 43,
    height: 43,
    transform: "rotate(-180 343 172)",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 171.499,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 128.738 171.499)",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 171.629,
    y: 171.499,
    width: 42.8928,
    height: 42.7215,
    transform: "rotate(-180 171.629 171.499)",
    fill: "#F9F5F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.619 171.499L171.629 159.275C171.629 159.275 171.629 159.275 171.619 159.275C166.547 159.275 162.417 155.162 162.417 150.11C162.417 145.058 166.547 140.945 171.619 140.945C171.619 140.945 171.619 140.945 171.629 140.945L171.629 128.721C171.629 128.721 171.629 128.721 171.619 128.721C159.774 128.721 150.144 138.312 150.144 150.11C150.144 161.908 159.774 171.499 171.619 171.499Z",
    fill: "#082C4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M342.99 171L343 158.999C343 158.999 343 158.999 342.99 158.999C337.796 158.999 333.567 154.96 333.567 150C333.567 145.04 337.796 141.001 342.99 141.001C342.99 141.001 342.99 141.001 343 141.001L343 129C343 129 343 129 342.99 129C330.861 129 321 138.417 321 150C321 161.583 330.861 171 342.99 171Z",
    fill: "#082C4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.523 128.75L171.574 128.75C171.574 140.548 181.204 150.139 193.049 150.139C204.894 150.139 214.523 140.548 214.523 128.75Z",
    fill: "#3098F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.223 86L257.273 86C257.273 97.7978 266.903 107.389 278.748 107.389C290.593 107.389 300.223 97.7978 300.223 86Z",
    fill: "#FE6571"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.524 86.028L202.251 86.0183C202.251 86.0183 202.251 86.0183 202.251 86.028C202.251 91.0801 198.121 95.1933 193.049 95.1933C187.977 95.1933 183.847 91.0801 183.847 86.028C183.847 86.028 183.847 86.028 183.847 86.0183L171.574 86.0183C171.574 86.0183 171.574 86.0183 171.574 86.028C171.574 97.8258 181.204 107.417 193.049 107.417C204.894 107.417 214.524 97.8258 214.524 86.028Z",
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    y: 86,
    width: 42.8928,
    height: 42.7215,
    fill: "url(#pattern0)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 257.301,
    y: 42.9717,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(180 257.301 42.9717)",
    fill: "#F4EEE7"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 214.41,
    y: 42.9717,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(180 214.41 42.9717)",
    fill: "#3098F3"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 343.086,
    y: 42.9717,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(180 343.086 42.9717)",
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 300.195,
    y: 42.9717,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(180 300.195 42.9717)",
    fill: "#082C4E"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 257.301,
    y: 85.9424,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(180 257.301 85.9424)",
    fill: "#FE6571"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 214.41,
    y: 85.9424,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(180 214.41 85.9424)",
    fill: "#082C4E"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 343.086,
    y: 85.9424,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(180 343.086 85.9424)",
    fill: "#FFCC00"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 300.195,
    y: 85.9424,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(180 300.195 85.9424)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.326 43.0282V0C245.481 0 235.852 9.64728 235.852 21.5141C235.852 33.381 245.481 43.0282 257.326 43.0282Z",
    fill: "#3098F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.297 0V43.0282C269.142 43.0282 278.772 33.381 278.772 21.5141C278.772 9.64728 269.142 0 257.297 0Z",
    fill: "#F2EAE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300 43.0014L312.272 43.0112C312.272 43.0112 312.272 43.0112 312.272 43.0014C312.272 37.9198 316.402 33.7825 321.474 33.7825C326.547 33.7825 330.677 37.9198 330.677 43.0014C330.677 43.0014 330.677 43.0014 330.677 43.0112L342.949 43.0112C342.949 43.0112 342.949 43.0112 342.949 43.0014C342.949 31.1346 333.32 21.4873 321.474 21.4873C309.629 21.4873 300 31.1346 300 43.0014Z",
    fill: "#FE6571"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M171.516 42.9717V85.9999C183.361 85.9999 192.99 76.3526 192.99 64.4858C192.99 52.619 183.361 42.9717 171.516 42.9717Z",
    fill: "#F2EAE2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8945,
    y: 43.0293,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 42.8945 43.0293)",
    fill: "#FE6571"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 171.57,
    y: 43.0293,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 171.57 43.0293)",
    fill: "#FFCC00"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 171.57,
    y: 43.0293,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 171.57 43.0293)",
    fill: "#FFCC00"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 128.68,
    y: 43.0293,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 128.68 43.0293)",
    fill: "#082C4E"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 128.68,
    y: 43.0293,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 128.68 43.0293)",
    fill: "#082C4E"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 85.6445,
    y: 43.0293,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 85.6445 43.0293)",
    fill: "#F2EAE2"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8945,
    y: 85.999,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 42.8945 85.999)",
    fill: "#082C4E"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8945,
    y: 85.999,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 42.8945 85.999)",
    fill: "#082C4E"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 171.57,
    y: 85.999,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 171.57 85.999)",
    fill: "#3098F3"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 85.7891,
    y: 85.999,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 85.7891 85.999)",
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 128.68,
    y: 85.999,
    width: 42.8928,
    height: 42.9714,
    transform: "rotate(-180 128.68 85.999)",
    fill: "#F9F5F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.67 85.999L128.68 73.7039C128.68 73.7039 128.68 73.7039 128.67 73.7039C123.598 73.7039 119.468 69.5665 119.468 64.4849C119.468 59.4033 123.598 55.266 128.67 55.266C128.67 55.266 128.67 55.266 128.68 55.266L128.68 42.9708C128.68 42.9708 128.68 42.9708 128.67 42.9708C116.825 42.9708 107.195 52.6181 107.195 64.4849C107.195 76.3517 116.825 85.999 128.67 85.999Z",
    fill: "#082C4E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M171.571 0.0288581L159.298 0.0191233C159.298 0.0191233 159.298 0.0191214 159.298 0.0288565C159.298 5.11047 155.168 9.2478 150.096 9.2478C145.024 9.2478 140.894 5.11047 140.894 0.0288541C140.894 0.0288541 140.894 0.028856 140.894 0.0191209L128.621 0.0191193C128.621 0.0191193 128.621 0.0191174 128.621 0.0288525C128.621 11.8957 138.251 21.543 150.096 21.543C161.941 21.543 171.571 11.8957 171.571 0.0288581Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0133362 0.000398609L0.0036613 12.3449C0.0036613 12.3449 0.00365749 12.3449 0.0133373 12.3449C5.0654 12.3449 9.17867 16.4988 9.17867 21.6008C9.17867 26.7028 5.0654 30.8567 0.0133389 30.8567C0.0133389 30.8567 0.0133408 30.8567 0.00366293 30.8567L0.00366402 43.2012C0.00366402 43.2012 0.0036602 43.2012 0.01334 43.2012C11.8112 43.2012 21.4023 33.5152 21.4023 21.6008C21.4023 9.68636 11.8112 0.000397572 0.0133362 0.000398609Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(0 -0.00200497) scale(0.00675676)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 148,
    height: 148,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciplesM);
export default __webpack_public_path__ + "static/media/principles-m.da174b8a27f5b58313479c4a4d856795.svg";
export { ForwardRef as ReactComponent };